import { hasBit } from './permissionCatalog'

// MANAGE_SERVER (edit name/icon/etc) and ADMINISTRATOR (bypass) bits, per
// permissionCatalog.ts. Mirrors the Phase-A backend `canManageServer`
// (owner OR global isAdmin OR a role bearing MANAGE_SERVER/ADMINISTRATOR) so
// the UI gate matches what PUT/DELETE /servers/:id actually allows.
const MANAGE_SERVER_BIT = 7
const ADMINISTRATOR_BIT = 11

type GateServer = {
  ownerId?: string | null
  members?: Array<{ userId: string; roles?: Array<{ role?: { permissions?: string } | null } | null> } | null>
}
type GateUser = { id: string; isAdmin?: boolean } | null | undefined

export function canManageServer(server: GateServer, user: GateUser): boolean {
  if (!user) return false
  if (user.isAdmin) return true
  if (server.ownerId && server.ownerId === user.id) return true
  const me = (server.members ?? []).find((m) => m != null && m.userId === user.id)
  if (!me) return false
  return (me.roles ?? []).some((r) => {
    const p = r?.role?.permissions ?? '0'
    return hasBit(p, MANAGE_SERVER_BIT) || hasBit(p, ADMINISTRATOR_BIT)
  })
}
